var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import color from 'color';
import React from 'react';
import { accentVariant, altVariant, altVariantText, black, borderGray, dangerVariant, divider, headingVariant, info, lightVariant, primary, primaryGray, successVariant, warningGlowBorder, white } from '../Styles/Colours';
function tint($color, $percentage) {
    return color($color)
        .mix(color(white), $percentage / 100)
        .string();
}
function shade($color, $percentage) {
    return color($color)
        .mix(color(black), $percentage / 100)
        .string();
}
function translucent($color, $percentage) {
    return color($color)
        .alpha($percentage / 100)
        .string();
}
export var ButtonMode;
(function (ButtonMode) {
    ButtonMode["solid"] = "solid";
    ButtonMode["border"] = "border";
    ButtonMode["text"] = "text";
    ButtonMode["glow"] = "glow";
})(ButtonMode || (ButtonMode = {}));
export var ButtonVariant;
(function (ButtonVariant) {
    ButtonVariant["primary"] = "primary";
    ButtonVariant["accent"] = "accent";
    ButtonVariant["light"] = "light";
    ButtonVariant["info"] = "info";
    ButtonVariant["success"] = "success";
    ButtonVariant["warning"] = "warning";
    ButtonVariant["danger"] = "danger";
    ButtonVariant["heading"] = "heading";
    ButtonVariant["gray"] = "gray";
    ButtonVariant["redBorder"] = "redBorder";
    ButtonVariant["lightGray"] = "lightGray";
})(ButtonVariant || (ButtonVariant = {}));
export var ButtonSize;
(function (ButtonSize) {
    ButtonSize["small"] = "small";
    ButtonSize["medium"] = "medium";
    ButtonSize["large"] = "large";
})(ButtonSize || (ButtonSize = {}));
export var ButtonGroupStyle;
(function (ButtonGroupStyle) {
    ButtonGroupStyle[ButtonGroupStyle["Left"] = 0] = "Left";
    ButtonGroupStyle[ButtonGroupStyle["Center"] = 1] = "Center";
    ButtonGroupStyle[ButtonGroupStyle["Right"] = 2] = "Right";
})(ButtonGroupStyle || (ButtonGroupStyle = {}));
var buttonColors = function (props) {
    return function (base, solidText, borderText, shaded) {
        var _a, _b;
        var result = {
            backgroundColor: base,
            color: solidText,
            hover: {
                backgroundColor: tint(base, 20)
            },
            focus: {
                backgroundColor: tint(base, 20)
            },
            active: {
                backgroundColor: tint(base, 20)
            },
            disabled: {
                backgroundColor: tint(base, 50),
                color: tint(solidText, 50),
                hover: {
                    backgroundColor: tint(base, 50),
                    borderColor: base
                },
                focus: {
                    backgroundColor: tint(base, 50),
                    borderColor: base
                }
            }
        };
        var buttonMode = (_a = props.mode) !== null && _a !== void 0 ? _a : ButtonMode.solid;
        var buttonVariant = (_b = props.variant) !== null && _b !== void 0 ? _b : ButtonVariant.primary;
        if (buttonMode === ButtonMode.solid) {
            result = {
                backgroundColor: base,
                color: solidText,
                hover: {
                    backgroundColor: tint(base, 20)
                },
                focus: {
                    backgroundColor: tint(base, 20)
                },
                active: {
                    backgroundColor: tint(base, 20)
                },
                disabled: {
                    backgroundColor: tint(base, 50),
                    color: tint(solidText, 50),
                    hover: {
                        backgroundColor: tint(base, 50),
                        borderColor: base
                    },
                    focus: {
                        backgroundColor: tint(base, 50),
                        borderColor: base
                    }
                }
            };
        }
        else if (buttonMode === ButtonMode.border) {
            result = {
                backgroundColor: white,
                color: borderText,
                border: "1px solid " + tint(base, 10),
                hover: {
                    backgroundColor: shaded ? shade(base, 5) : tint(base, 90)
                },
                focus: {
                    backgroundColor: shaded ? shade(base, 5) : tint(base, 90)
                },
                active: {
                    backgroundColor: shaded ? shade(base, 5) : tint(base, 90)
                },
                disabled: {
                    borderColor: tint(base, 50),
                    color: tint(borderText, 50),
                    hover: {
                        backgroundColor: white,
                        borderColor: tint(base, 50)
                    },
                    focus: {
                        backgroundColor: white,
                        borderColor: tint(base, 50)
                    }
                }
            };
        }
        else if (buttonMode === ButtonMode.text) {
            result = {
                backgroundColor: 'transparent',
                color: borderText,
                hover: {
                    backgroundColor: props.subtleShadeOnHover
                        ? translucent(base, 10)
                        : shaded
                            ? shade(base, 5)
                            : tint(base, 90)
                },
                focus: {
                    backgroundColor: props.subtleShadeOnHover
                        ? translucent(base, 10)
                        : shaded
                            ? shade(base, 5)
                            : tint(base, 90)
                },
                active: {
                    backgroundColor: props.subtleShadeOnHover
                        ? translucent(base, 10)
                        : shaded
                            ? shade(base, 5)
                            : tint(base, 90)
                },
                disabled: {
                    borderColor: tint(base, 50),
                    color: tint(borderText, 50),
                    hover: {
                        backgroundColor: 'transparent',
                        borderColor: tint(base, 50)
                    },
                    focus: {
                        backgroundColor: 'transparent',
                        borderColor: tint(base, 50)
                    }
                }
            };
        }
        if ((buttonVariant === ButtonVariant.light || buttonVariant === ButtonVariant.redBorder || buttonVariant === ButtonVariant.lightGray) &&
            (buttonMode === ButtonMode.border || buttonMode === ButtonMode.solid)) {
            result.border = buttonVariant === ButtonVariant.redBorder ? "2px solid " + dangerVariant : "1px solid " + divider;
            result.backgroundColor = base;
            result.hover.borderColor = buttonVariant === ButtonVariant.redBorder ? dangerVariant : divider;
            result.hover.backgroundColor = tint(divider, 50);
            result.focus.borderColor = buttonVariant === ButtonVariant.redBorder ? dangerVariant : divider;
            result.focus.backgroundColor = tint(divider, 50);
            result.disabled.border = buttonVariant === ButtonVariant.redBorder ? "2px solid " + dangerVariant : "2px solid " + divider;
            result.disabled.hover.borderColor = buttonVariant === ButtonVariant.redBorder ? dangerVariant : divider;
            result.disabled.focus.borderColor = buttonVariant === ButtonVariant.redBorder ? dangerVariant : divider;
        }
        if (props.buttonGroup === ButtonGroupStyle.Left) {
            result.borderRadius = "2px 0 0 2px";
            result.borderRight = 'none';
            result.disabled.borderRight = 'none';
        }
        else if (props.buttonGroup === ButtonGroupStyle.Center) {
            result.borderRadius = '0';
            result.borderRight = 'none';
            result.disabled.borderRight = 'none';
        }
        else if (props.buttonGroup === ButtonGroupStyle.Right) {
            result.borderRadius = '0 2px 2px 0';
        }
        return result;
    };
};
var useStyles = makeStyles({
    button: function (props) {
        var buttonColorStyles = buttonColors(props)(primary, white, primary, false);
        if (props.variant === ButtonVariant.primary) {
            buttonColorStyles = buttonColors(props)(primary, white, primary, false);
        }
        else if (props.variant === ButtonVariant.accent) {
            buttonColorStyles = buttonColors(props)(accentVariant, white, accentVariant, false);
        }
        else if (props.variant === ButtonVariant.light) {
            buttonColorStyles = buttonColors(props)(lightVariant, primaryGray, borderGray, true);
        }
        else if (props.variant === ButtonVariant.info) {
            buttonColorStyles = buttonColors(props)(info, white, info, false);
        }
        else if (props.variant === ButtonVariant.success) {
            buttonColorStyles = buttonColors(props)(successVariant, white, successVariant, false);
        }
        else if (props.variant === ButtonVariant.warning) {
            buttonColorStyles = buttonColors(props)(warningGlowBorder, black, warningGlowBorder, false);
        }
        else if (props.variant === ButtonVariant.danger) {
            buttonColorStyles = buttonColors(props)(dangerVariant, white, dangerVariant, false);
        }
        else if (props.variant === ButtonVariant.heading) {
            buttonColorStyles = buttonColors(props)(headingVariant, white, headingVariant, false);
        }
        else if (props.variant === ButtonVariant.gray) {
            buttonColorStyles = buttonColors(props)(primaryGray, white, borderGray, false);
        }
        else if (props.variant === ButtonVariant.redBorder) {
            buttonColorStyles = buttonColors(props)(white, primaryGray, dangerVariant, false);
        }
        else if (props.variant === ButtonVariant.lightGray) {
            buttonColorStyles = buttonColors(props)(altVariant, altVariantText, divider, false);
        }
        var padding = '0 16px';
        var height = 40;
        var fontSize = 16;
        var minWidth = '112';
        var width;
        var borderRadius = '2';
        if (props.smallText) {
            fontSize = 14;
        }
        else if (props.size === ButtonSize.small) {
            padding = '0 12px';
            height = 32;
            fontSize = 14;
            minWidth = '100';
        }
        else if (props.size === ButtonSize.large) {
            height = 48;
        }
        if (props.iconOnly) {
            borderRadius = '50%';
            width = 40;
            minWidth = 'auto';
            if (props.size === ButtonSize.small) {
                width = 32;
            }
            else if (props.size === ButtonSize.large) {
                height = 48;
            }
            if (props.squareIcon) {
                borderRadius = 'unset';
            }
        }
        return __assign(__assign({ padding: padding, border: 'transparent', backgroundColor: primary, color: white, cursor: "pointer", transition: "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms", fontFamily: "'Source Sans Pro', -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif", fontWeight: 600, fontSize: fontSize, minWidth: minWidth, borderRadius: borderRadius, height: height, width: width, outline: "0", boxShadow: 'none' }, buttonColorStyles), { '&:hover': __assign(__assign({}, buttonColorStyles.hover), { boxShadow: props.noShadowOnHover
                    ? "none"
                    : "0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0, 0, 0, 0.12)" }), '&:focus': __assign(__assign({}, buttonColorStyles.focus), { boxShadow: props.noShadowOnHover
                    ? "none"
                    : "0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0, 0, 0, 0.12)" }), '&:active': __assign(__assign({}, buttonColorStyles.active), { boxShadow: 'none' }), '&:disabled': __assign(__assign({ cursor: "default" }, buttonColorStyles.disabled), { '&:hover': __assign(__assign({}, buttonColorStyles.disabled.hover), { boxShadow: 'none' }), '&:focus': __assign(__assign({}, buttonColorStyles.disabled.focus), { boxShadow: 'none' }) }) });
    },
    label: {
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: 'center',
        alignItems: 'center'
    },
    children: function (props) {
        var styles = {
            flex: '1 1 100%',
            display: 'flex',
            justifyContent: 'center'
        };
        if (props.tighterIcons) {
            styles.flexGrow = 0;
            styles.flexBasis = 'auto;';
        }
        return styles;
    },
    startIcon: {
        marginRight: 8,
        display: 'flex',
        'button:disabled &': {
            opacity: 0.5
        }
    },
    endIcon: {
        marginLeft: 8,
        display: 'flex',
        'button:disabled &': {
            opacity: 0.5
        }
    },
    buttonGroupLeft: {
        borderRadius: '2px 0 0 2px',
        borderRight: 'none',
        '&:disabled': {
            borderRight: 'none'
        }
    },
    buttonGroupCentre: {
        borderRadius: 0,
        borderRight: 'none',
        '&:disabled': {
            borderRight: 'none'
        }
    },
    buttonGroupRight: {
        borderRadius: '0 2px 2px 0'
    }
});
export var Button = React.forwardRef(function (props, ref) {
    var _a;
    var disabled = props.disabled, variant = props.variant, size = props.size, otherProps = __rest(props, ["disabled", "variant", "size"]);
    var cssInJsClasses = useStyles(props);
    var style = __assign(__assign({}, otherProps.style), { width: otherProps.width, minWidth: otherProps.width });
    if (otherProps.borderColour) {
        style.borderColor = otherProps.borderColour;
    }
    var classes = classNames(cssInJsClasses.button, otherProps.className, (_a = {},
        _a[cssInJsClasses.buttonGroupLeft] = otherProps.buttonGroup === ButtonGroupStyle.Left,
        _a[cssInJsClasses.buttonGroupCentre] = otherProps.buttonGroup === ButtonGroupStyle.Center,
        _a[cssInJsClasses.buttonGroupRight] = otherProps.buttonGroup === ButtonGroupStyle.Right,
        _a));
    var startIcon = !!otherProps.startIcon && (React.createElement("span", { className: cssInJsClasses.startIcon }, otherProps.startIcon));
    var endIcon = !!otherProps.endIcon && React.createElement("span", { className: cssInJsClasses.endIcon }, otherProps.endIcon);
    var button = (React.createElement("button", { ref: ref, className: classes, onClick: otherProps.onClick, style: style, disabled: disabled, "data-test-id": "button_" + otherProps.testId, type: otherProps.type, title: otherProps.title },
        React.createElement("span", { className: cssInJsClasses.label },
            startIcon,
            React.createElement("span", { className: cssInJsClasses.children }, otherProps.children),
            endIcon)));
    return props.tooltip ? React.createElement(Tooltip, { title: props.tooltip }, button) : button;
});
